import * as React from 'react';
import { UspGroup } from '@grandvisionhq/content';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@swc/helpers';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import '@grandvisionhq/state';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsPolicyBar = ({ content , theme ='default'  })=>{
    var ref;
    if (!(content === null || content === void 0 ? void 0 : (ref = content.policyItems) === null || ref === void 0 ? void 0 : ref.length)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(UspGroup, {
        items: content.policyItems,
        theme: theme
    });
};
var PolicyBar = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsPolicyBar);

export { CmsPolicyBar, PolicyBar as default };
//# sourceMappingURL=PolicyBar.js.map
